import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import { removeTextStyleAction } from 'editor/src/store/design/slice';
import saveUndoRedoStateOperation from 'editor/src/store/editorModules/undoRedo/operation/saveUndoRedoStateOperation';
import type { ThunkDispatch } from 'editor/src/store/hooks';

/** Deletes a style; its texts keep their look and stop following it. One undo step. */
const removeTextStyleOperation = (styleId: string) => (dispatch: ThunkDispatch) => {
  batch(() => {
    dispatch(saveUndoRedoStateOperation('Text style removed'));
    dispatch(removeTextStyleAction(styleId));
  });
};

export default removeTextStyleOperation;
